/**
 * @generated SignedSource<<701fd332ed53d2cb2b14b8ba05e3859a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type StreamAccessType = "full" | "partial" | "shared";
export type ShareModalQuery$variables = {
  streamId: string;
};
export type ShareModalQuery$data = {
  readonly account: {
    readonly allowPublicLink: boolean;
  };
  readonly noteStream: {
    readonly displayName: string;
    readonly id: string;
    readonly isExternal: boolean;
    readonly pendingStreamInvites: ReadonlyArray<{
      readonly email: string;
      readonly id: string;
      readonly isExpired: boolean;
    }> | null;
    readonly publicLink: {
      readonly enabled: boolean;
      readonly url: string;
    } | null;
    readonly viewerNotestreamuser: {
      readonly accessType: StreamAccessType;
      readonly id: string;
    } | null;
  } | null;
  readonly viewer: {
    readonly user: {
      readonly id: string;
      readonly isGuest: boolean;
    };
  };
};
export type ShareModalQuery = {
  response: ShareModalQuery$data;
  variables: ShareModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "streamId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isGuest",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowPublicLink",
  "storageKey": null
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "streamId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isExternal",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enabled",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "NoteStreamInvite",
  "kind": "LinkedField",
  "name": "pendingStreamInvites",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isExpired",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "NoteStreamUser",
  "kind": "LinkedField",
  "name": "viewerNotestreamuser",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accessType",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ShareModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "NoteStream",
        "kind": "LinkedField",
        "name": "noteStream",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStreamPublicLink",
            "kind": "LinkedField",
            "name": "publicLink",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          (v9/*: any*/),
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ShareModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "NoteStream",
        "kind": "LinkedField",
        "name": "noteStream",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStreamPublicLink",
            "kind": "LinkedField",
            "name": "publicLink",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          (v9/*: any*/),
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "471853f1e5252dc039e33182f5407857",
    "id": null,
    "metadata": {},
    "name": "ShareModalQuery",
    "operationKind": "query",
    "text": "query ShareModalQuery(\n  $streamId: ID!\n) {\n  viewer {\n    user {\n      id\n      isGuest\n    }\n    id\n  }\n  account {\n    allowPublicLink\n    id\n  }\n  noteStream(id: $streamId) {\n    id\n    displayName\n    isExternal\n    publicLink {\n      url\n      enabled\n      id\n    }\n    pendingStreamInvites {\n      id\n      email\n      isExpired\n    }\n    viewerNotestreamuser {\n      id\n      accessType\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5bba27c1c3be7e6548afa2d003bba414";

export default node;
